import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store/types/TStore';

export const selfSurveyManagement = (state: RootState) => state.survey;

export const selectViewMode = createSelector(
  [selfSurveyManagement],
  ({ isViewMode }) => isViewMode,
);

export const selectSurveyToken = createSelector(
  [selfSurveyManagement],
  ({ surveyToken }) => surveyToken,
);
